<template>
  <div>
    <el-dialog :close-on-click-modal="false" :show-close="false" v-if="visible" :model-value="visible"
      @update:modelValue="(val) => { if (!val) modal.closePandyTransferItem(); visible = val }" width="80%">
      <template #title>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <span>Item</span>
          <el-button size="small" type="warning" @click="resetForm">Reset</el-button>
        </div>
      </template>

      <el-form :model="pandyTransferItem" ref="formRef" :rules="rules" label-width="140px" size="small">
        <el-row :gutter="24">

          <!-- Column 1: Identity & input -->
          <el-col :span="8">
            <el-form-item v-show="pandyTransferItem.ptItemNo" label="Item No:">
              <el-input v-model="pandyTransferItem.ptItemNo" disabled style="width: 100%" />
            </el-form-item>
            <el-form-item label="Of:" prop="of">
              <el-select v-model="pandyTransferItem.of" :disabled="isDetail" placeholder="Select" style="width: 100%">
                <el-option v-for="item in ofOptions.toList().filter(o => [1, 2].includes(o.id))" :key="item.id"
                  :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="SKU:" prop="sku">
              <div @click="modal.openSku()" style="width: 100%">
                <el-input v-model="pandyTransferItem.sku" placeholder="Click to select sku" readonly
                  :disabled="isDetail" style="width: 100%" />
              </div>
            </el-form-item>
            <el-form-item label="Inventory Type:" prop="inventoryType">
              <el-select v-model="pandyTransferItem.inventoryType" @change="resetValues" :disabled="isDetail"
                style="width: 100%">
                <el-option v-for="item in inventoryType.toList()" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Code:" prop="refNo">
              <el-row :gutter="8" style="width: 100%">
                <el-col :span="16">
                  <el-input v-model="pandyTransferItem.refNo" :disabled="isDetail" style="width: 100%" />
                </el-col>
                <el-col :span="8">
                  <el-button v-if="!isDetail" type="primary" @click="handleSearch" style="width: 100%">ADD</el-button>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-show="pandyTransferItem.slotCode" label="Slot Code:">
              <el-input v-model="pandyTransferItem.slotCode" disabled style="width: 100%" />
            </el-form-item>
            <el-form-item label="Note:">
              <el-input type="textarea" v-model="pandyTransferItem.note" :disabled="isDetail" style="width: 100%" />
            </el-form-item>
          </el-col>

          <!-- Column 2: Weight & quantity -->
          <el-col :span="8">
            <el-form-item label="Category:">
              <el-input v-model="pandyTransferItem.categoryName" disabled style="width: 100%" />
            </el-form-item>
            <el-form-item v-show="pandyTransferItem.quality" label="Quality:">
              <el-input v-model="pandyTransferItem.quality" disabled style="width: 100%" />
            </el-form-item>
            <el-form-item label="Wt Unit:">
              <el-select v-model="pandyTransferItem.wtUnit" disabled style="width: 100%">
                <el-option v-for="item in wtUnitOptions.toList()" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>

            <!-- KPY weight -->
            <el-form-item v-if="pandyTransferItem.wtUnit == 3" label="Total Wt.:" prop="wtStr">
              <el-row :gutter="4" style="width: 100%">
                <el-col :span="8">
                  <el-input type="number" v-model="rawWt.totalK" placeholder="ကျပ်" @blur="formatGold"
                    :disabled="pandyTransferItem.inventoryType == inventoryType.GDProductCatalog.id"
                    style="width: 100%" />
                </el-col>
                <el-col :span="8">
                  <el-input type="number" v-model="rawWt.totalP" placeholder="ပဲ" @blur="formatGold"
                    :disabled="pandyTransferItem.inventoryType == inventoryType.GDProductCatalog.id"
                    style="width: 100%" />
                </el-col>
                <el-col :span="8">
                  <el-input type="number" v-model="rawWt.totalY" placeholder="ရွေး" @blur="formatGold"
                    :disabled="pandyTransferItem.inventoryType == inventoryType.GDProductCatalog.id"
                    style="width: 100%" />
                </el-col>
              </el-row>
            </el-form-item>

            <!-- Gram weight -->
            <el-form-item v-else label="Total Wt.:" prop="wtStr">
              <el-input type="number" v-model="rawWt.totalG" placeholder="g" @blur="formatGold"
                :disabled="pandyTransferItem.inventoryType == inventoryType.GDProductCatalog.id" style="width: 100%" />
            </el-form-item>

            <el-form-item label="Quantity:" prop="qty">
              <el-row :gutter="8" style="width: 100%">
                <el-col :span="12">
                  <el-input type="number" min="1" step="1" v-model="pandyTransferItem.qty"
                    :disabled="pandyTransferItem.inventoryType == inventoryType.GDProductCatalog.id"
                    style="width: 100%" />
                </el-col>
                <el-col :span="12">
                  <el-select v-model="pandyTransferItem.qtyUnit" disabled style="width: 100%">
                    <el-option v-for="item in qtyUnitOptions.toList()" :key="item.id" :label="item.name"
                      :value="item.id" />
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>

          <!-- Column 3: Return/Receive info -->
          <el-col :span="8">
            <h3 style="color: red; text-align: center; margin: 0 0 18px 0;">{{ recRet }}</h3>
            <el-form-item :label="'Is ' + recRet + ':'">
              <span>{{ pandyTransferItem.isReturnedReceived == 1 ? 'Yes' : 'No' }}</span>
            </el-form-item>
            <el-form-item label="DateTime:">
              <el-date-picker v-model="pandyTransferItem.returnedReceivedAt" type="datetime" format="YYYY-MM-DD HH:mm"
                value-format="YYYY-MM-DD HH:mm:ss" disabled style="width: 100%" />
            </el-form-item>
            <el-form-item label="Branch:">
              <el-input v-model="pandyTransferItem.returnedReceivedBranchName" disabled style="width: 100%" />
            </el-form-item>
            <el-form-item v-show="pandyTransferItem.returnedReceivedSlotCode" label="Slot Code:">
              <el-input v-model="pandyTransferItem.returnedReceivedSlotCode" disabled style="width: 100%" />
            </el-form-item>
            <el-form-item v-if="recRet !== 'Received'" label="Customer Name:">
              <div @click="modal.openCustomer()" style="width: 100%">
                <el-input v-model="pandyTransferItem.returnedCustomerSmithName" placeholder="Click to select customer"
                  readonly disabled style="width: 100%" />
              </div>
            </el-form-item>
            <el-form-item label="Employee Name:">
              <div @click="modal.openEmployee()" style="width: 100%">
                <el-input v-model="pandyTransferItem.receivedEmployeeName" placeholder="Click to select employee"
                  readonly disabled style="width: 100%" />
              </div>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <template #footer>
        <template v-if="isDetail">
          <el-button type="primary" @click="modal.closePandyTransferItem(); visible = false" size="small">OK</el-button>
        </template>
        <template v-else>
          <el-button @click="modal.closePandyTransferItem(); visible = false" size="small">Cancel</el-button>
          <el-button type="primary" @click="handlePandyTransferItemDialogConfirm" size="small">Confirm</el-button>
        </template>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { isReturnedReceived, pandyType, inventoryType, rateType, qtyUnitOptions, wtUnitOptions, prFormulaOptions, ofOptions, prUnitOptions } from '@/utils/constants'
import { fetchProductForPandyTransfer } from '@/api/pandy_transfer_item'
import { getLatestList } from '@/api/currency'
import { useModalStore } from '@/stores/modal'
import { useLoading } from '@/composables/useLoading'
import { defaultPandyTransferItem, defaultPandyTransferItemRawWt as defaultRawWt } from './defaults'
import { useShopDataStore } from '@/stores/shopData'
import { kpyToKyat } from '@/composables/useGoldWeight'

const modal = useModalStore()
const shopDataStore = useShopDataStore()
const { setLoading } = useLoading()
const formRef = ref(null)

const visible = ref(false)
const isDetail = ref(false)
const recRet = ref('')
const skuPlace = ref(null)
const tmpTotalWt = ref(0)
const tmpQty = ref(0)
const rateList = ref([])
const pandyTransferItem = ref({ ...defaultPandyTransferItem })
const rawWt = ref({ ...defaultRawWt })

const rules = {
  refNo: [{ required: true, message: 'This field is required', trigger: 'blur' }],
  sku: [{ required: true, message: 'This field is required', trigger: 'change' }]
}

onMounted(async () => {
  try {
    const rateResponse = await getLatestList()
    rateList.value = rateResponse.data.list
  } catch (e) { /* ignore */ }
})

watch(() => modal.customer.selected, (val) => {
  if (val && visible.value) {
    pandyTransferItem.value.returnedCustomerSmithName = val.name
    pandyTransferItem.value.returnedCustomerSmithId = val.id
  }
})

watch(() => modal.employee.selected, (val) => {
  if (val && visible.value) {
    pandyTransferItem.value.receivedEmployeeName = val.name
    pandyTransferItem.value.receivedEmployeeId = val.id
  }
})

watch(() => modal.sku.selected, (val) => {
  if (val && visible.value) {
    pandyTransferItem.value.sku = val.code
    skuPlace.value = val.place
  }
})

watch(() => modal.pandyTransferItem.visible, (val) => {
  if (val) {
    const params = modal.pandyTransferItem.data
    pandyTransferItem.value = { ...defaultPandyTransferItem }
    rawWt.value = { ...defaultRawWt }
    isDetail.value = params.isDetail
    recRet.value = params.recRet

    if (params.pandyTransferItem) {
      pandyTransferItem.value = { ...params.pandyTransferItem }
      initializedWeight()
    } else {
      pandyTransferItem.value.place = params.place
      setDefaultSku()
    }
    visible.value = true
  } else {
    visible.value = false
  }
}, { immediate: true })

watch(() => pandyTransferItem.value.of, () => {
  setDefaultSku()
})

function setDefaultSku() {
  const match = shopDataStore.defaultSkuList.find(sku =>
    sku.place === pandyTransferItem.value.place &&
    sku.of === pandyTransferItem.value.of &&
    sku.parentCategoryId === 60
  )
  if (match) pandyTransferItem.value.sku = match.code
}

function resetForm() {
  formRef.value?.resetFields()
  rawWt.value = { ...defaultRawWt }
  pandyTransferItem.value = { ...defaultPandyTransferItem }
}

function resetValues() {
  const inv = pandyTransferItem.value.inventoryType
  const ofOption = pandyTransferItem.value.of
  const place = pandyTransferItem.value.place
  rawWt.value = { ...defaultRawWt }
  pandyTransferItem.value = { ...defaultPandyTransferItem, inventoryType: inv, of: ofOption, place }
}

function formatGold() {
  if (pandyTransferItem.value.wtUnit == 3) {
    pandyTransferItem.value.wt = kpyToKyat({ kyat: rawWt.value.totalK, pal: rawWt.value.totalP, yway: rawWt.value.totalY }).wt
    pandyTransferItem.value.wtStr = `${rawWt.value.totalK || 0}-${rawWt.value.totalP || 0}-${rawWt.value.totalY || 0}`
  } else {
    const temp = parseFloat(rawWt.value.totalG) || 0
    pandyTransferItem.value.wt = temp
    pandyTransferItem.value.wtStr = temp + ''
  }
}

function initializedWeight() {
  if (pandyTransferItem.value.wtUnit == 3) {
    const t = pandyTransferItem.value.wtStr?.split('-') || []
    rawWt.value.totalK = t[0] || null; rawWt.value.totalP = t[1] || null; rawWt.value.totalY = t[2] || null
  } else {
    rawWt.value.totalG = pandyTransferItem.value.wt
  }
}

async function handleSearch() {
  try {
    setLoading(true)
    const response = await fetchProductForPandyTransfer({
      inventoryType: pandyTransferItem.value.inventoryType,
      place: pandyTransferItem.value.place,
      refCode: pandyTransferItem.value.refNo
    })
    // if (!response.data) {
    //   ElMessage.error('No product found with this code.')
    //   const place = pandyTransferItem.value.place
    //   pandyTransferItem.value = { ...defaultPandyTransferItem, place, sku: pandyTransferItem.value.sku }
    //   return
    // }
    pandyTransferItem.value = { ...response.data, note: null, sku: pandyTransferItem.value.sku }
    pandyTransferItem.value.ptItemNo = Date.now()
    tmpTotalWt.value = pandyTransferItem.value.wt
    tmpQty.value = pandyTransferItem.value.qty
    initializedWeight()
  } catch (e) {
    // error handled by request interceptor
  } finally {
    setLoading(false)
  }
}

async function handlePandyTransferItemDialogConfirm() {
  const valid = await formRef.value.validate().catch(() => false)
  if (!valid) return

  if (skuPlace.value !== pandyTransferItem.value.place) {
    ElMessage.error('Item Place and Sku Place should be the same.')
    return
  }
  if (pandyTransferItem.value.wt > tmpTotalWt.value || pandyTransferItem.value.qty > tmpQty.value) {
    ElMessage.error(pandyTransferItem.value.wt > tmpTotalWt.value ? 'Total weight exceeds the available weight.' : 'Total quantity exceeds the available quantity.')
    return
  }

  ElMessageBox.confirm(`Are you sure you want to create this item?`, 'Warning', {
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    type: 'warning'
  }).then(async () => {
    modal.pandyTransferItem.data = { ...pandyTransferItem.value, _validated: true }
    modal.closePandyTransferItem()
    visible.value = false
  }).catch(() => { })
}
</script>

<style scoped>
:deep(.el-form-item__content) {
  width: 100%;
}
</style>
